export default __webpack_public_path__ + "static/media/IMG3775.f10c9fc6.jpg";